import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const InviteToEnrollMutation = graphql.persisted(
  "InviteToEnroll",
  graphql(`
    mutation InviteToEnroll($input: InviteToEnrollInput!) {
      inviteToEnroll(input: $input) {
        results { familyEnrollmentId status reason }
        errors
      }
    }
  `)
);

export { InviteToEnrollMutation };

export function useInviteToEnroll() {
  return useMutation(InviteToEnrollMutation);
}
